import {
    request
} from '../lib/http_request'
import {
    apis
} from '../lib/apis'

// 公告列表
const noticeList = obj => new Promise((resolve, reject) => {
    const {
        token
    } = obj
    request({
        url: apis.notice_guide_list + '?token=' + token
    }).then(res => {
        resolve(res);
    })
})

// 创建公告
const noticeSend = obj => new Promise((resolve, reject) => {
    const {
        noticeForm,
        token
    } = obj
    request({
        url: apis.notice_guide_send + '?token=' + token,
        data: noticeForm
    }).then(res => {
        resolve(res);
    })
})

// 编辑公告
const noticeEdit = obj => new Promise((resolve, reject) => {
    const {
        noticeForm,
        token
    } = obj
    request({
        url: apis.notice_guide_edit + '?token=' + token ,
        data: noticeForm
    }).then(res => {
        resolve(res);
    })
})

// 删除公告
const noticeDelete = obj => new Promise((resolve, reject) => {
    const {
        noticeForm,
        token
    } = obj
    request({
        url: apis.notice_guide_delete + '?token=' + token ,
        data: noticeForm
    }).then(res => {
        resolve(res);
    })
})


export default {
    noticeList,
    noticeSend,
    noticeEdit,
    noticeDelete
}



// WEBPACK FOOTER //
// ./src/service/notice_guide_api.js